import React, { Component } from 'react';
import logoImage from './LOGOBLACK.png'

class App extends Component {
  render() {
    return (
      <div className="app-container">
        <div className="section">
          <div className="blurbs">
            <div className="blurb">{`1. I’m Ryan.`}</div>
            <div className="blurb">{`2. I don’t settle for jabberwocky.`}</div>
            <div className="blurb">
            {`3. I disrupt the status quo through:`}
            <div className="indent">{`a. Globally-minded, action-oriented wordsmithing`}</div>
            <div className="indent">{`b. Organizational problem-solving`}</div>
            </div>
            <div className="blurb">Yeah? <div><a href="mailto:ryeryeelwood@gmail.com">Let’s grab coffee.</a></div></div>
          </div>
        </div>
        <div className="scroll-helper">👇</div>
        <div className="section night">
          <div className="">READ Global</div>
        </div>
        <style jsx>{`
          :global(body) {
            margin: 0;
            padding: 0;
            font-family: sans-serif;
          }

          .app-container{
            font-family: Roboto;
          }
          a{
            color: black;
          }

          .section{
            height: 100vh;
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .section.night{
            background: black;
            color: white;
          }

          .blurbs{
            max-width: 500px;
            font-size: 24px;
            font-weight: 900;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 20px;
          }

          .blurb{
            margin-bottom: 20px;
          }

          .indent{
            padding-left: 2rem;
          }

          .scroll-helper{
            position: absolute;
            bottom: 20px;
            width: 100%;
            text-align: center;
            font-size: 32px;

          }
        `}</style>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js